import React from "react";
import { User, Location, putCommasIntoNumber } from "@ecologi/shared";
import { CarbonEquivalents } from "./components/CarbonEquivalents";
import { Section, BackgroundVariant } from "../Section";
import styles from "./ProfileImpact.module.scss";
import { Link } from "../Link";

export type ProfileImpactProps = {
  isOwnProfile: boolean;
  user: User;
  location: Location;
};

export const ProfileImpact = (props: ProfileImpactProps) => {
  const { isOwnProfile, user, location } = props;

  let name = isOwnProfile
    ? "Your"
    : user.isFamilyPlan
    ? user.fullNamePlural
    : user.firstNamePlural;
  name = user.isBusinessPlan || !user.subscription ? user.fullNamePlural : name;
  const title = `${name} impact visualised`;

  return (
    <Section
      className={styles.profileImpact}
      backgroundVariant={BackgroundVariant.GREY}
      id="tour-impact-equivalents"
      isExtraLarge
    >
      <Section.HeadingWrapper marginBottomOverride="0">
        <Section.Title use="sectionTitle" as="h2">
          {title}
        </Section.Title>
        <Section.Subtitle use="subtitle2" as="h3">
          {isOwnProfile ? "Your " : ""}
          <strong>
            {putCommasIntoNumber(user.totalNumberOfTonnesOffset())} tonnes
          </strong>{" "}
          of CO
          <sub>2</sub>e is equivalent to one of the following
        </Section.Subtitle>
        {isOwnProfile && (
          <Link href="/dashboard">
            <Section.Link use="standaloneLink" as="p">
              Go to your dashboard
            </Section.Link>
          </Link>
        )}
      </Section.HeadingWrapper>

      <div className={styles.profileImpactCards}>
        <CarbonEquivalents user={user} location={location} />
      </div>
    </Section>
  );
};
